import StudentStatusPeriod from "@/components/student/StatusPeriod";
import StudentStatusSubject from "@/components/student/StatusSubject";
import StudentStatusSemester from "@/components/student/StatusSemester";
import ProfessorStatusPeriod from "@/components/professor/StatusPeriod";
import ProfessorStatusSubject from "@/components/professor/StatusSubject";
import ProfessorStatusSemester from "@/components/professor/StatusSemester";

export const routes = [{
  path: '/student/status-semester',
  name: '/student/status-semester',
  component: StudentStatusSemester,
}, {
  path: '/student/status-period',
  name: '/student/status-period',
  component: StudentStatusPeriod,
}, {
  path: '/student/status-subject',
  name: '/student/status-subject',
  component: StudentStatusSubject,
}, {
  path: '/professor/status-semester',
  name: '/professor/status-semester',
  component: ProfessorStatusSemester,
}, {
  path: '/professor/status-period',
  name: '/professor/status-period',
  component: ProfessorStatusPeriod,
}, {
  path: '/professor/status-subject',
  name: '/professor/status-subject',
  component: ProfessorStatusSubject,
}];
